import React, {useEffect, useMemo, useRef, useState} from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const FILTER_DEBOUNCE_MILLISECONDS = 300;

const DebouncedColumnFilter = ({column}) => {
    const columnFilterValue = column.getFilterValue() || "";
    const [value, setValue] = useState(columnFilterValue);
    const appliedValueRef = useRef(columnFilterValue);
    const columnRef = useRef(column);
    columnRef.current = column;

    const applyFilter = useMemo(() => _.debounce(
        (filterValue) => {
            appliedValueRef.current = filterValue || "";
            columnRef.current.setFilterValue(filterValue || undefined);
        },
        FILTER_DEBOUNCE_MILLISECONDS
    ), []);

    useEffect(() => () => applyFilter.cancel(), [applyFilter]);

    useEffect(() => {
        if (columnFilterValue === appliedValueRef.current) return;
        applyFilter.cancel();
        appliedValueRef.current = columnFilterValue;
        setValue(columnFilterValue);
    }, [columnFilterValue, applyFilter]);

    return <input
        data-testid={`${column.id}-filter-input`}
        value={value}
        onChange={(event) => {
            setValue(event.target.value);
            applyFilter(event.target.value);
        }}
        onKeyDown={(event) => {
            if (event.key === 'Enter') applyFilter.flush();
        }}
    />;
};

DebouncedColumnFilter.propTypes = {
    column: PropTypes.shape({
        id: PropTypes.string,
        getFilterValue: PropTypes.func,
        setFilterValue: PropTypes.func
    }).isRequired
};

export default DebouncedColumnFilter;
